import Cookies from "js-cookie";

const TOKEN_KEY = "token";

export function setToken(
  token,
  options = { expires: 7, path: "/", sameSite: "lax" }
) {
  try {
    Cookies.set(TOKEN_KEY, token, options);
  } catch (err) {
    // ignore cookie errors in some environments
  }
}

export function getToken() {
  try {
    return Cookies.get(TOKEN_KEY);
  } catch (err) {
    return undefined;
  }
}

export function removeToken() {
  try {
    Cookies.remove(TOKEN_KEY);
  } catch (err) {
    // ignore
  }
}

export default { setToken, getToken, removeToken };
